import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "@/lib/api";
import { inputCls, PageHead } from "./ui";

export default function AdminInventory() {
  const [items, setItems] = useState([]);
  const [moves, setMoves] = useState([]);
  const [stock, setStock] = useState("");
  useEffect(() => { api.get("/admin/products", { params: { stock: stock || undefined } }).then((r) => setItems(r.data)); }, [stock]);
  useEffect(() => { api.get("/admin/movements", { params: { limit: 30 } }).then((r) => setMoves(r.data)); }, []);
  return (
    <div data-testid="admin-inventory">
      <PageHead title="Magazzino" subtitle="Disponibilità, venduti e storico movimenti">
        <select data-testid="inventory-filter" value={stock} onChange={(e) => setStock(e.target.value)} className={inputCls}>
          <option value="">Tutti</option><option value="unique">Pezzi unici</option><option value="low">Sotto soglia</option><option value="out">Esauriti</option>
        </select>
      </PageHead>
      <div className="grid xl:grid-cols-[1.4fr_1fr] gap-5 items-start">
        <div className="bg-white/60 border border-[#D5B98C]/50 overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[10px] uppercase tracking-widest text-[#956842] text-left border-b border-[#D5B98C]/50">
              <th className="p-3">Prodotto</th><th className="p-3 text-right">Disp.</th><th className="p-3 text-right">Ris.</th><th className="p-3 text-right">Venduti</th><th className="p-3 text-right hidden sm:table-cell">Prezzo</th>
            </tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} data-testid={`inventory-row-${p.id}`} className={`border-b border-[#D5B98C]/30 ${p.stock === 0 ? "bg-[#8a2f22]/5" : p.stock <= (p.min_stock ?? 1) ? "bg-[#956842]/5" : ""}`}>
                  <td className="p-3"><Link to={`/admin/prodotti/${p.id}`} className="hover:text-[#956842]"><div className="font-medium">{p.name}</div><div className="text-xs text-[#242321]/55">{p.sku}</div></Link></td>
                  <td className="p-3 text-right font-semibold">{p.stock}</td>
                  <td className="p-3 text-right">{p.reserved || 0}</td>
                  <td className="p-3 text-right">{p.sold || 0}</td>
                  <td className="p-3 text-right hidden sm:table-cell">{formatPrice(p.sale_price ?? p.price)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-white/60 border border-[#D5B98C]/50 p-5" data-testid="inventory-movements">
          <h2 className="font-serif text-2xl text-[#39251D] mb-3">Movimenti recenti</h2>
          <ul className="divide-y divide-[#D5B98C]/40 text-sm">
            {moves.map((m) => (
              <li key={m.id} className="py-2">
                <div><b>{m.sku}</b> · <span className="capitalize">{m.type}</span> {m.delta > 0 ? `+${m.delta}` : m.delta} → {m.stock_after}</div>
                <div className="text-[11px] text-[#242321]/50">{new Date(m.at).toLocaleString("it-IT")} · {m.user_email}{m.note ? ` · ${m.note}` : ""}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
